import * as React from 'react'
import { connect } from 'react-redux'

import { navigateToForm } from '../../actions/forms'
import { RootState } from '../../types/rootstate'

interface StateProps {
  agentId: number
}

interface DispatchProps {
  navigateToForm: (userId: number, agentId: number, formId: number) => void
}

interface OwnProps {
  connectedFormId: number
  label: string
  isSticky: boolean
  userId: number
}

type FormButtonProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state: RootState): StateProps {
  return {
    agentId: state.widget.agentId
  }
}

function mapDispatchToProps (dispatch): DispatchProps {
  return {
    navigateToForm: (userId, agentId, formId) =>
      dispatch(navigateToForm(userId, agentId, formId))
  }
}

interface FormButtonState {
}

class FormButtonComponent extends React.Component<FormButtonProps, FormButtonState> {
  handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (this.props.connectedFormId) {
      this.props.navigateToForm(this.props.userId, this.props.agentId, this.props.connectedFormId)
    }
  }

  handleButtonKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()

      if (this.props.connectedFormId) {
        this.props.navigateToForm(this.props.userId, this.props.agentId, this.props.connectedFormId)
      }
    }
  }

  render () {
    return (
      <div className={'fromButton ' + (this.props.isSticky ? 'isSticky' : 'notSticky')}>
        <div className="button primary accentSecondary">
          <span
            onClick={this.handleButtonClick}
            onKeyDown={this.handleButtonKeyDown}
            role='button'
            tabIndex={0}
          >
            {this.props.label}
          </span>
        </div>
      </div>
    )
  }
}

const FormButton = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(FormButtonComponent)


export {
  FormButton
}
